export default __webpack_public_path__ + "static/teamPhoto1-6833b273467dde7de8de30c0bce5afc6.png";